module.exports = __webpack_public_path__ + "static/media/striped_bar_postlapSMAP.3145b503.svg";